import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.browseGroups.query.gql"
import type {
  FeatureBrowseGroupsQuery,
  FeatureBrowseGroupsQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/compose/__types__/license.featureGroup.browseGroups.query"

type Options = QueryHookOptions<
  FeatureBrowseGroupsQuery,
  FeatureBrowseGroupsQueryVariables
>

export function useFeatureBrowseGroupsQuery(options?: Options) {
  return useQuery<FeatureBrowseGroupsQuery, FeatureBrowseGroupsQueryVariables>(
    query,
    options,
  )
}
